(function () {
  var MAX_RECOMMENDATIONS = 6;
  var lastSignature = '';

  function shopifyRoute(path) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    if (path.charAt(0) === '/') path = path.slice(1);
    return root + path;
  }

  function getCustomerLocale() {
  var config = window.axiLocalization || {};
  var country = String(config.country || '').toUpperCase();

  var countryLocales = {
    SI: 'sl-SI',
    DE: 'de-DE',
    AT: 'de-AT',
    FR: 'fr-FR',
    IT: 'it-IT',
    ES: 'es-ES',
    PT: 'pt-PT',
    NL: 'nl-NL',
    BE: 'nl-BE',
    LU: 'fr-LU',
    IE: 'en-IE',
    FI: 'fi-FI',
    EE: 'et-EE',
    LV: 'lv-LV',
    LT: 'lt-LT',
    GR: 'el-GR',
    HR: 'hr-HR',
    SK: 'sk-SK',
    CY: 'el-CY',
    MT: 'mt-MT',
    BG: 'bg-BG',
    CZ: 'cs-CZ',
    DK: 'da-DK',
    HU: 'hu-HU',
    PL: 'pl-PL',
    RO: 'ro-RO',
    SE: 'sv-SE',
    GB: 'en-GB',
    US: 'en-US',
    CA: 'en-CA',
    AU: 'en-AU'
  };

  if (countryLocales[country]) {
    return countryLocales[country];
  }

  return (
    config.language ||
    document.documentElement.lang ||
    navigator.language ||
    'en'
  );
}

function formatMoney(cents, currencyCode) {
  var config = window.axiLocalization || {};
  var currency = currencyCode || config.currency || 'EUR';

  try {
    return new Intl.NumberFormat(getCustomerLocale(), {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  } catch (error) {
    return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + currency;
  }
}


  function getUpsellTarget() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return null;

    var protectionRow = drawer.querySelector('.axi-protection-row');
    if (protectionRow) {
      return { parent: protectionRow.parentNode, sibling: protectionRow };
    }

    var summary = drawer.querySelector('.cart-drawer__summary');
    if (summary) {
       return { parent: summary, sibling: summary.firstChild };
    }

    return { parent: drawer.querySelector('.cart-drawer__items'), sibling: null };
  }

  function removeUpsell() {
    var existing = document.querySelector('.axi-upsell-wrap');
    if (existing) existing.remove();
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = '···';
    fetch(shopifyRoute('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: cart.item_count, source: 'axi-upsell' } }
        }));
        btn.textContent = '✓';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+';
      });
  }

  function buildCard(product, currencyCode) {
  var variant = product.variants && product.variants[0];
  if (!variant) return null;

  var image =
    product.featured_image ||
    (product.images && product.images[0]) ||
    '';

  var productUrl = product.url || '#';
  var productTitle = String(product.title || '');

  var safeTitle = productTitle
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  var card = document.createElement('article');
  card.className = 'axi-upsell-card';

  var imageHtml = image
    ? '<img src="' +
      image +
      '" alt="' +
      safeTitle +
      '" loading="lazy">'
    : '';

  card.innerHTML =
    '<a class="axi-upsell-image" href="' + productUrl + '">' +
      imageHtml +
    '</a>' +
    '<div class="axi-upsell-info">' +
      '<a class="axi-upsell-title" href="' + productUrl + '">' +
        safeTitle +
      '</a>' +
      '<p class="axi-upsell-price">' +
        formatMoney(variant.price, currencyCode) +
      '</p>' +
    '</div>' +
    '<button type="button" class="axi-upsell-add" aria-label="Add ' +
      safeTitle +
      ' to cart">+</button>';

  card
    .querySelector('.axi-upsell-add')
    .addEventListener('click', function (event) {
      addToCart(variant.id, event.currentTarget);
    });

  return card;
}

function insertUpsell(products, currencyCode) {
  var target = getUpsellTarget();
  if (!target || !target.parent) return;

  removeUpsell();

  var wrap = document.createElement('section');
  wrap.className = 'axi-upsell-wrap';

  var header = document.createElement('div');
  header.className = 'axi-upsell-header';

  var heading = document.createElement('p');
  heading.className = 'axi-upsell-heading';
  heading.textContent = 'You may also like';

  var controls = document.createElement('div');
  controls.className = 'axi-upsell-controls';

  var previous = document.createElement('button');
  previous.type = 'button';
  previous.className =
    'axi-upsell-arrow axi-upsell-arrow--previous';
  previous.setAttribute(
    'aria-label',
    'Previous recommendations'
  );
  previous.innerHTML = '&#8592;';

  var next = document.createElement('button');
  next.type = 'button';
  next.className =
    'axi-upsell-arrow axi-upsell-arrow--next';
  next.setAttribute(
    'aria-label',
    'Next recommendations'
  );
  next.innerHTML = '&#8594;';

  controls.appendChild(previous);
  controls.appendChild(next);

  header.appendChild(heading);
  header.appendChild(controls);
  wrap.appendChild(header);

  var list = document.createElement('div');
  list.className = 'axi-upsell-list';

  products.forEach(function (product) {
    var card = buildCard(product, currencyCode);
    if (card) list.appendChild(card);
  });

  wrap.appendChild(list);

  if (target.sibling) {
    target.parent.insertBefore(wrap, target.sibling);
  } else {
    target.parent.appendChild(wrap);
  }

  function getScrollAmount() {
    var card = list.querySelector('.axi-upsell-card');
    return card ? (card.offsetWidth + 10) : list.clientWidth * 0.75;
  }

  previous.addEventListener('click', function () {
    list.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  next.addEventListener('click', function () {
    list.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });
}

function renderUpsell(force) {
    var target = getUpsellTarget();
    if (!target) return;

    fetch(shopifyRoute('cart.js'))
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          removeUpsell();
          return;
        }

        var cartProductIds = cart.items.map(function (i) { return i.product_id; });
        var signature = cartProductIds.join(',');
        if (!force && signature === lastSignature && document.querySelector('.axi-upsell-wrap')) return;
        lastSignature = signature;

        var seedProductId = cart.items[0].product_id;

        fetch(shopifyRoute('recommendations/products.json') + '?product_id=' + seedProductId + '&limit=6&intent=related')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var candidates = (data.products || [])
              .filter(function (p) { return cartProductIds.indexOf(p.id) === -1 && p.available; })
              .slice(0, MAX_RECOMMENDATIONS);

            if (!candidates.length) {
              removeUpsell();
              return;
            }

            insertUpsell(candidates, cart.currency);
          })
          .catch(function () {});
      })
      .catch(function () {});
  }

  function watchDialog() {
    var drawer = document.querySelector('cart-drawer-component');
    var dialog = drawer ? drawer.querySelector('dialog') : null;
    if (!drawer || !dialog) {
      setTimeout(watchDialog, 500);
      return;
    }

    var renderTimer = null;
    function scheduleRender() {
      if (!dialog.open) return;
      clearTimeout(renderTimer);
      renderTimer = setTimeout(function () { renderUpsell(false); }, 200);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.attributeName === 'open') {
          if (dialog.open) scheduleRender();
          continue;
        }
        if (m.type === 'childList') scheduleRender();
      }
    });
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open'],
      childList: true,
      subtree: true
    });

    if (dialog.open) scheduleRender();
  }

  document.addEventListener('cart:update', function () {
    setTimeout(function () { renderUpsell(true); }, 350);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDialog);
  } else {
    watchDialog();
  }
})();